import { render, staticRenderFns } from "./Artwork.vue?vue&type=template&id=0bbaa156&scoped=true&"
import script from "./Artwork.vue?vue&type=script&lang=js&"
export * from "./Artwork.vue?vue&type=script&lang=js&"
import style0 from "./Artwork.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Artwork.vue?vue&type=style&index=1&id=0bbaa156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbaa156",
  null
  
)

export default component.exports